import { Title, Text } from '@libs/ui/ds'
import { useCounterModulationTranslation } from '@libs/utils/translations'
import classnames from 'classnames'
import React, { useCallback, useEffect, useRef } from 'react'

import styles from './ModalTooltip.module.css'
import modulationInfos from './ModulationInfos'

const ContentModal = ({ keyTooltip }) => {
  const { t } = useCounterModulationTranslation()
  const cardRef = useRef('')

  const scroll = useCallback(() => {
    setTimeout(() => {
      // @ts-ignore migration from js(x) to ts(x)
      cardRef.current.scrollIntoView({
        block: 'center',
        behavior: 'smooth'
      })

      cardRef.current = ''
    }, 50)
  }, [cardRef])

  useEffect(() => {
    if (cardRef?.current) {
      scroll()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardRef])

  return (
    <div className={styles.Container}>
      {/* @ts-ignore migration from js(x) to ts(x) */}
      {modulationInfos(t)
        .valueSeq()
        .map(info => {
          // @ts-ignore migration from js(x) to ts(x)
          const selected = info.id === keyTooltip

          const props = {}

          if (selected) {
            // @ts-ignore migration from js(x) to ts(x)
            props.ref = cardRef
          }

          return (
            <div
              className={classnames(
                styles.Card,
                selected && styles.SelectedCard
              )}
              // @ts-ignore migration from js(x) to ts(x)
              key={info.id}
              {...props}
            >
              <Title size={2} className={styles.ContentText}>
                {info?.title}
              </Title>
              <Text size='m' className={styles.ContentText}>
                {info?.content}
              </Text>
            </div>
          )
        })}
    </div>
  )
}

export default ContentModal
